// CardNavigation.jsx
import LeftIcon from "../components/icons/LeftIcon";
import RightIcon from "../components/icons/RightIcon";

export default function CardNavigation({
    currentIndex,
    numDisplayedCards,
    numCards,
    category,
    isLocked,
    onPrev,
    onNext,
}) {
    return (
        <div className="flex justify-between items-center gap-4">
            <button className="btn btn-primary" onClick={onPrev} disabled={currentIndex === 0}>
                <LeftIcon />
            </button>
            <div className="flex flex-col items-center text-center">
                <p className="text-sm">
                    {isLocked && "Preview "}Card {currentIndex + 1} of {numDisplayedCards}
                </p>
                {isLocked ? (
                    <p className="text-xs text-gray-400 mt-1">Full deck includes {numCards} cards</p>
                ) : (
                    <p className="text-xs text-gray-500">{category}</p>
                )}
            </div>
            <button
                className="btn btn-primary"
                onClick={onNext}
                disabled={!isLocked && currentIndex === numDisplayedCards - 1}
            >
                <RightIcon />
            </button>

        </div>
    );
}
